"use client";

import React from "react";
import { usePathname } from "next/navigation";

/** Footer subscribe form: compact, one row (the button wraps under the field only on very narrow screens). */
export default function FooterNewsletter() {
    const pathname = usePathname();
    const [email, setEmail] = React.useState("");
    const [status, setStatus] = React.useState<"idle" | "loading" | "success" | "error">("idle");
    const [message, setMessage] = React.useState("");
    const [mounted, setMounted] = React.useState(false);

    React.useEffect(() => {
        setMounted(true);
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!email) return;

        setStatus("loading");
        setMessage("");

        const pageName = pathname === "/" ? "Homepage" : pathname;
        const source = `Footer (Page: ${pageName})`;

        try {
            const res = await fetch("/api/subscribe", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, source }),
            });

            const data = await res.json();

            if (!res.ok) throw new Error(data.error || "Failed to subscribe");

            setStatus("success");
            setMessage(data.message);
            setEmail("");
        } catch (error: any) {
            setStatus("error");
            setMessage(error.message);
        }
    };

    return (
        <form onSubmit={handleSubmit} suppressHydrationWarning>
            <div className="cs-subscribe">
                <div className="cs-subscribe__field">
                    {mounted ? (
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            aria-label="Email address"
                            autoComplete="email"
                            inputMode="email"
                            disabled={status === "loading" || status === "success"}
                            className="cs-subscribe__input"
                            required
                            data-lpignore="true"
                        />
                    ) : (
                        <div className="h-[44px] w-full rounded-lg border border-white/10 bg-black/40" />
                    )}
                </div>
                <button
                    type="submit"
                    disabled={status === "loading" || status === "success"}
                    className="cs-subscribe__button"
                >
                    {status === "loading" ? "..." : status === "success" ? "✓" : "Go"}
                </button>
            </div>
            {message && (
                <p role="status" className={`text-xs mt-2 ${status === "error" ? "text-red-400" : "text-cs-accent"}`}>
                    {message}
                </p>
            )}
        </form>
    );
}
